var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmallLogo = function SvgSmallLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 51,
    viewBox: "0 0 65 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1927 20.626C52.7133 31.6641 43.3641 40.1978 32.079 40.1978C20.7939 40.1978 11.4446 31.6641 9.96521 20.626H0C1.52888 37.2138 15.3328 50.2375 32.079 50.2375C48.8251 50.2375 62.6236 37.2138 64.1579 20.626H54.1927V20.626Z",
    fill: "#0E1F3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0789 29.4274C40.0914 29.4274 46.5867 22.8399 46.5867 14.7137C46.5867 6.58756 40.0914 0 32.0789 0C24.0664 0 17.571 6.58756 17.571 14.7137C17.571 22.8399 24.0664 29.4274 32.0789 29.4274Z",
    fill: "#FF8778"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmallLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/small-logo.919f19feec943fa32161bd657d79e457.svg";